import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const data = [
  { day: 'Mon', present: 140, absent: 10 },
  { day: 'Tue', present: 138, absent: 12 },
  { day: 'Wed', present: 145, absent: 5 },
  { day: 'Thu', present: 142, absent: 8 },
  { day: 'Fri', present: 150, absent: 0 },
];

const AttendanceChart = () => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="day" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="present" stroke="#82ca9d" />
        <Line type="monotone" dataKey="absent" stroke="#ff7300" />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AttendanceChart;
